module.exports = __webpack_public_path__ + "static/media/Vivo-step3.fa9c1b03.png";